import { render, staticRenderFns } from "./Manage_question.vue?vue&type=template&id=58f8702f&scoped=true&"
import script from "./Manage_question.vue?vue&type=script&lang=js&"
export * from "./Manage_question.vue?vue&type=script&lang=js&"
import style0 from "./Manage_question.vue?vue&type=style&index=0&id=58f8702f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f8702f",
  null
  
)

export default component.exports